import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUnreadEmails } from "store/actions/Emails";
import { EmailState } from "store/reducers/Emails";
import { RootState } from "store/store";
import { syncEnabledTenantWebPushSubscriptions } from "services/WebPush";

interface Props {
  emailState: EmailState;
}

interface Actions {
  getUnreadEmails: () => void;
}

interface BadgingNavigator extends Navigator {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
}

const setBadgeCount = (count: number) => {
  const badgingNavigator = navigator as BadgingNavigator;
  if (count === 0 && badgingNavigator.setAppBadge) {
    badgingNavigator.setAppBadge(0).catch(() => {
      if (badgingNavigator.clearAppBadge) {
        badgingNavigator.clearAppBadge().catch(() => undefined);
      }
    });
    return;
  }

  if (count > 0 && badgingNavigator.setAppBadge) {
    badgingNavigator.setAppBadge(count).catch(() => undefined);
    return;
  }

  if (count === 0 && badgingNavigator.clearAppBadge) {
    badgingNavigator.clearAppBadge().catch(() => undefined);
  }
};

const AppBadgeSync: React.FC<Props & Actions> = ({ emailState, getUnreadEmails }) => {
  const hasFetchedEmails = emailState.isFetched();
  const unread = emailState.getEmails().filter(email => email.direction === "in" && !email.IsRead()).length;

  useEffect(() => {
    getUnreadEmails();
  }, [getUnreadEmails]);

  useEffect(() => {
    syncEnabledTenantWebPushSubscriptions().catch(() => undefined);
  }, []);

  useEffect(() => {
    if (!hasFetchedEmails) {
      return;
    }

    setBadgeCount(unread);
  }, [hasFetchedEmails, unread]);

  return null;
};

const mapStateToProps = (state: RootState) => {
  return {
    emailState: state.Emails,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ getUnreadEmails }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AppBadgeSync);
